// extracted by css-extract-rspack-plugin
export default {"cls1":"search_work_card_redesign-cls1_wEe","cls2":"search_work_card_redesign-cls2_rm7 search_work_card_redesign-cls1_wEe"};